import React from 'react';
import { View } from '../types';
import { Shield, BookOpen, UserCheck, Activity, Award, Type, GraduationCap, LayoutDashboard, Terminal } from 'lucide-react';

interface NavbarProps {
  currentView: View;
  setView: (v: View) => void;
  dyslexiaMode: boolean;
  toggleDyslexia: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ currentView, setView, dyslexiaMode, toggleDyslexia }) => {
  const navItems = [
    { view: View.HOME, label: 'Start', icon: <Shield size={18} /> },
    { view: View.LEARN, label: 'Learn', icon: <BookOpen size={18} /> },
    { view: View.SANDBOX, label: 'Simulator', icon: <Terminal size={18} /> },
    { view: View.COMPARE, label: 'Compare', icon: <Activity size={18} /> },
    { view: View.DEFEND, label: 'Defend', icon: <UserCheck size={18} /> },
    { view: View.CASES, label: 'Cases', icon: <Activity size={18} /> },
    { view: View.ASSESSMENT, label: 'Exam', icon: <Award size={18} /> },
  ];

  return (
    <nav className="bg-cyber-dark text-white p-4 sticky top-0 z-50 shadow-lg print:hidden">
      <div className="max-w-7xl mx-auto flex flex-col xl:flex-row justify-between items-center">
        <div className="text-xl font-bold flex items-center gap-2 mb-4 xl:mb-0 cursor-pointer" onClick={() => setView(View.HOME)}>
          <Shield className="text-cyber-accent" />
          <span>Malware<span className="text-cyber-accent">Basics</span></span>
        </div>
        
        <div className="flex flex-wrap justify-center gap-2">
          {navItems.map((item) => (
            <button
              key={item.view}
              onClick={() => setView(item.view)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all text-sm font-medium ${
                currentView === item.view 
                  ? 'bg-cyber-accent text-white' 
                  : 'hover:bg-slate-700 text-slate-300'
              }`}
            >
              {item.icon}
              <span className="hidden lg:inline">{item.label}</span>
            </button>
          ))}

          <div className="h-8 w-px bg-slate-700 mx-2 hidden md:block"></div>

          <button
            onClick={() => setView(View.DASHBOARD)}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all text-sm font-medium ${
              currentView === View.DASHBOARD 
                ? 'bg-purple-600 text-white' 
                : 'hover:bg-slate-700 text-purple-300'
            }`}
            title="My Progress"
          >
            <LayoutDashboard size={18} />
            <span className="hidden lg:inline">Progress</span>
          </button>

          <button
            onClick={() => setView(View.TEACHER)}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all text-sm font-medium ${
              currentView === View.TEACHER 
                ? 'bg-yellow-600 text-white' 
                : 'hover:bg-slate-700 text-yellow-500'
            }`}
            title="Teacher Resources"
          >
            <GraduationCap size={18} />
          </button>
          
          <button
            onClick={toggleDyslexia}
            className={`p-2 rounded-lg border ml-2 ${dyslexiaMode ? 'bg-yellow-100 text-black border-yellow-400' : 'border-slate-600 text-slate-400'}`}
            title="Toggle Dyslexia Friendly Mode"
            aria-label="Toggle Dyslexia Friendly Mode"
          >
            <Type size={20} />
          </button>
        </div>
      </div>
    </nav>
  );
};
